import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, matchPath, Outlet, useLocation } from 'react-router-dom';
import { Grid, Paper, Tab, Tabs } from '@mui/material';

import { RouterPaths } from '../../router/paths';
import { permissionsCheck } from '../../utils/permission';

export const Dictionaries: FC = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const hasPermissionToViewCompanyTypes = permissionsCheck(['READ_COMPANY_TYPES']);
  const hasPermissionToViewCountries = permissionsCheck(['READ_COUNTRIES']);

  // active tab logic
  const tabsPaths = [RouterPaths.Countries, RouterPaths.CompanyTypes];
  const activeTab = tabsPaths.filter((path) => matchPath(path, pathname))[0];

  return (
    <>
      <Grid size={{ xs: 12 }}>
        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
          <Tabs value={activeTab} variant="scrollable" scrollButtons="auto">
            {hasPermissionToViewCountries && (
              <Tab
                label={t('dictionaries.tabs.countries')}
                component={Link}
                to={RouterPaths.Countries}
                value={RouterPaths.Countries}
                sx={{ textTransform: 'none' }}
              />
            )}
            {hasPermissionToViewCompanyTypes && (
              <Tab
                label={t('dictionaries.tabs.company-types')}
                component={Link}
                to={RouterPaths.CompanyTypes}
                value={RouterPaths.CompanyTypes}
                sx={{ textTransform: 'none' }}
              />
            )}
          </Tabs>
        </Paper>
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
          <Outlet />
        </Paper>
      </Grid>
    </>
  );
};
